import { useContext } from "react"
import { AuthContext } from "./AuthProvider.context";
import { TAuthContext } from "./AuthProvider.type";

export const useAuth = (): TAuthContext => {
    const context = useContext(AuthContext);
    if(context === null) {
        throw new Error("useAuthContext deve ser usado dentro de um AuthProvider");
    }

    return context;
};